import "./index.css";
import App from "./App";
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { EmotionColorProvider } from "./components/emotions/contexts/EmotionColorContext";

const root = createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <EmotionColorProvider>
        <App />
      </EmotionColorProvider>
    </BrowserRouter>
  </React.StrictMode>
);
